/**
 * Carga las condiciones de despacho una vez por visita a la tienda.
 *
 * Se monta en el armazon de la tienda y no en la raiz de la aplicacion: el
 * backoffice no necesita esto —tiene su propia pantalla, con mas datos— y
 * pedirlo ahi seria una peticion por gusto en cada entrada al panel.
 *
 * Si la peticion falla no se rompe nada: las pantallas que anuncian el monto
 * simplemente no lo anuncian. Es preferible a mostrar un monto de respaldo que
 * podria no ser el que se cobra.
 */
import { useMemo } from 'react';
import type { ReactNode } from 'react';

import { usePeticion } from '../hooks/use-peticion';
import { obtenerOpcionesDespacho } from '../servicios/despacho.servicio';
import { ContextoDespacho, type ValorDespacho } from './despacho-contexto';

export function ProveedorDespacho({ children }: { children: ReactNode }) {
  const peticion = usePeticion((senal) => obtenerOpcionesDespacho(senal), []);
  const valor = useMemo<ValorDespacho>(() => ({ opciones: peticion.datos }), [peticion.datos]);

  return <ContextoDespacho.Provider value={valor}>{children}</ContextoDespacho.Provider>;
}
